import { useMemo } from "react";
import { useSdk } from "../../contexts/services/hooks/use-services-context";
import type { ConversationSummary } from "../../managers/conversation/types/conversation";

export type AssistantHistory = {
    listConversations: (query?: string) => Promise<ConversationSummary[]>;
    renameConversation: (id: string, title: string) => Promise<void>;
    deleteConversation: (id: string) => Promise<void>;
    deleteAllConversations: () => Promise<void>;
};

export function useAssistantHistory(): AssistantHistory {
    const { conversationManager } = useSdk();

    return useMemo<AssistantHistory>(
        () => ({
            listConversations: (...args) =>
                conversationManager.listConversations(...args),
            renameConversation: (...args) =>
                conversationManager.renameConversation(...args),
            deleteConversation: (...args) =>
                conversationManager.deleteConversation(...args),
            deleteAllConversations: () =>
                conversationManager.deleteAllConversations(),
        }),
        [conversationManager],
    );
}
